import { render, staticRenderFns } from "./HeroAside.vue?vue&type=template&id=4d51e70a&scoped=true&"
import script from "./HeroAside.vue?vue&type=script&lang=js&"
export * from "./HeroAside.vue?vue&type=script&lang=js&"
import style0 from "./HeroAside.vue?vue&type=style&index=0&id=4d51e70a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d51e70a",
  null
  
)

export default component.exports